"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { ProficienciesCarousel } from "@/ui/carousel/proficiencies-carousel";
export function CarouselWithFade() {
  const $ = _c(3);
  const containerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const container = containerRef.current;
      if (container) {
        const updateFadeWidth = () => {
          const fadeWidth = window.innerWidth < 640 ? "5%" : "10%";
          container.style.setProperty("--fade-width", fadeWidth);
        };
        updateFadeWidth();
        window.addEventListener("resize", updateFadeWidth);
        return () => window.removeEventListener("resize", updateFadeWidth);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-full"><div className="relative w-full overflow-hidden" ref={containerRef}><div className="from-background pointer-events-none absolute inset-y-0 left-0 z-10 w-[var(--fade-width)] bg-gradient-to-r to-transparent" /><div className="from-background pointer-events-none absolute inset-y-0 right-0 z-10 w-[var(--fade-width)] bg-gradient-to-l to-transparent" /><ProficienciesCarousel /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}